import { createContext } from "react";
import { createEditVisitDataFromVisitId, Dispatch, EditVisitData } from "./editVisitModel";
import { LaborViewItem } from "./labor";

export type ContextData = EditVisitData & {
  dispatch: Dispatch
  googleMapsApiKey: string
  laborView: LaborViewItem[]
  defaultLunchBreakMinutes: number
}

export default createContext<ContextData>({
  ...createEditVisitDataFromVisitId('', 'America/New_York'),
  dispatch: () => { },
  googleMapsApiKey: '',
  laborView: [],
  defaultLunchBreakMinutes: 30
})
